import { PropsWithChildren } from 'react';
import { DateFNSConfigProvider as DateFNSConfigProviderBase } from '@nexelem/config';
import { useAuthContext } from './AuthProvider';

export const DateFNSConfigProvider = ({ children }: PropsWithChildren) => {
  const { user } = useAuthContext();

  return <DateFNSConfigProviderBase language={user?.language}>{children}</DateFNSConfigProviderBase>;
};
